var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcCabCapsuleAnketaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 2.25,
    width: 13.5,
    height: 17.5,
    rx: 2.75,
    stroke: "#36F6FF",
    strokeWidth: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 7.25H14.25M7.75 11H14.25M7.75 14.75H11.75",
    stroke: "#36F6FF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcCabCapsuleAnketaIcon);
export default __webpack_public_path__ + "static/media/tc_cab_capsule_anketa_icon.b61647849043e024f91b8aa5be97729e.svg";
export { ForwardRef as ReactComponent };